import { ThemeService } from "@wind-log_library/fe-component-library";

export class RatedPower {
  static generate(ratedPower: number, length: number) {
    return Array.from(Array(length), () => ratedPower);
  }

  static getRatedChartColor(themeService: ThemeService) {
    return {
      backgroundColor: 'transparent',
      borderColor: themeService.getColor('--font'),
      borderWidth: 1,
      pointBackgroundColor: 'transparent',
      pointBorderColor: 'transparent',
      pointRadius: 0,
      pointHoverBackgroundColor: 'transparent',
      pointHoverBorderColor: 'transparent'
    };
  }

  static getRatedChartLine() {
    return {
      label: '',
      type: 'line',
      borderDash: [5, 5],
      fill: false
    };
  }
}
